import { Building2, Cpu, Globe2, Users } from "lucide-react";

const STATS = [
  { icon: Building2, k: "15+", v: "Kurumsal müşteri" },
  { icon: Globe2, k: "1.2M+", v: "Yönetilen GIS varlık" },
  { icon: Users, k: "300+", v: "Aktif saha kullanıcısı" },
  { icon: Cpu, k: "%99.95", v: "Cloud SLA hedefi" },
];

export function Company() {
  return (
    <section id="sirket" className="border-b border-border/60 bg-card/30">
      <div className="container py-20 md:py-24">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr]">
          <div className="space-y-5">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
              RADGIS Hakkında
            </div>
            <h2 className="text-balance text-3xl font-semibold tracking-tight md:text-4xl">
              CBS, harita mühendisliği ve saha operasyonu için ortak omurga.
            </h2>
            <p className="text-pretty text-base text-muted-foreground md:text-lg">
              RADGIS; belediyelerden doğalgaz dağıtım şirketlerine, su ve kanalizasyon idarelerinden
              telekom operatörlerine kadar altyapı sahibi kurumlar için kurumsal CBS çözümleri
              geliştirir. Aynı platform; harita ve CBS mühendislik ofisleri ile bu kurumlara hizmet
              veren saha yüklenicileri tarafından da kullanılır.
            </p>
            <p className="text-pretty text-base text-muted-foreground md:text-lg">
              Ekibimiz coğrafi bilgi sistemleri, CAD mühendisliği ve dağıtık sistemler alanlarında
              derin deneyim taşır. Kurumsal güvenlik, veri egemenliği ve uzun vadeli
              sürdürülebilirlik geliştirme yaklaşımımızın merkezindedir.
            </p>
          </div>

          <dl className="grid grid-cols-2 gap-4">
            {STATS.map(({ icon: Icon, k, v }) => (
              <div
                key={v}
                className="rounded-2xl border border-border/60 bg-background p-6 shadow-soft"
              >
                <Icon className="h-5 w-5 text-muted-foreground" />
                <dt className="mt-6 text-3xl font-semibold tracking-tight md:text-4xl">{k}</dt>
                <dd className="mt-1 text-sm text-muted-foreground">{v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
